<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const router = useRouter();
const { t } = useI18n();

// 功能列表
const features = computed(() => [
  {
    id: 'update_leads_tool',
    title: t('INTEGRATION_SETTINGS.MIP.UPDATE_LEADS_TOOL.TITLE'),
    description: t('INTEGRATION_SETTINGS.MIP.UPDATE_LEADS_TOOL.DESCRIPTION'),
    route: 'mip_leads_update_leads_tool',
    available: true,
  },
]);

// 进入功能
const enterFeature = feature => {
  if (feature.available && feature.route) {
    router.push({ name: feature.route });
  }
};
</script>

<template>
  <div class="overflow-auto p-4 w-full my-auto flex flex-wrap h-full">
    <div class="w-full space-y-4">
      <div
        v-for="feature in features"
        :key="feature.id"
        class="outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow flex-grow overflow-auto p-4"
        :class="{ 'opacity-60 cursor-not-allowed': !feature.available }"
      >
        <div class="flex items-center justify-center">
          <div class="flex h-16 w-16 items-center justify-center">
            <img
              :src="'/dashboard/images/integrations/mip.png'"
              class="max-w-full rounded-md border border-n-weak shadow-sm block dark:hidden bg-n-alpha-3"
            />
            <img
              :src="'/dashboard/images/integrations/mip-dark.png'"
              class="max-w-full rounded-md border border-n-weak shadow-sm hidden dark:block bg-n-alpha-3"
            />
          </div>
          <div class="flex flex-col justify-center m-0 mx-4 flex-1">
            <h3 class="mb-1 text-xl font-medium text-n-slate-12">
              {{ feature.title }}
            </h3>
            <p class="text-n-slate-11 text-sm leading-6">
              {{ feature.description }}
            </p>
          </div>
          <div class="flex justify-center items-center mb-0 w-[15%]">
            <Button
              v-if="feature.available"
              blue
              faded
              :label="$t('INTEGRATION_SETTINGS.CONNECT.BUTTON_TEXT')"
              @click="enterFeature(feature)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
